// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-expandable-textfield-icon:not(.disabled) {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}

/*# sourceMappingURL=ExpandableTextField.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ExpandableTextField/ExpandableTextField.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/ExpandableTextField/ExpandableTextField.css"],"names":[],"mappings":"AACA;EACI,wBC2JW;EC3Jb,kDAAkD;AACpD;;AAEA,kDAAkD","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
